import { render, staticRenderFns } from "./SearchCustomerComponent.vue?vue&type=template&id=63c07b2c"
import script from "./SearchCustomerComponent.vue?vue&type=script&lang=ts"
export * from "./SearchCustomerComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports